import React from 'react';
import PropTypes from 'prop-types';
import DataCard from '../../../common/card/DataCard';

export const PickupDeliveryDetails = ({ data, title, onEdit }) => {
  if (!data) return null;

  const {
    deliveryProvider,
    address1,
    city,
    firstLevelSubdivisionCode,
    totalDeliveryCost,
    courierTip,
    status,
    thirdPartyDeliveryId,
    providerBatchId,
  } = data;

  const jobIdUrl =
    window.location.host === 'internal.trycents.com'
      ? `https://portal.usenash.com/active/${thirdPartyDeliveryId}`
      : `https://portal.sandbox.usenash.com/active/${thirdPartyDeliveryId}`;

  const details = [
    { label: `${title} Provider`, data: deliveryProvider },
    { label: `${title} Information`, data: `${address1}, ${city}, ${firstLevelSubdivisionCode}` },
    { label: `${title} Cost`, data: Number(totalDeliveryCost).toFixed(2), currency: true },
    { label: `${title} Tip`, data: Number(courierTip).toFixed(2), currency: true },
    { label: 'Status', data: status, editable: true },
    ...(deliveryProvider === 'ON_DEMAND'
      ? [
          { label: 'Job ID', data: thirdPartyDeliveryId, type: 'external-link', href: jobIdUrl },
          { label: 'Provider Batch ID', data: providerBatchId || '--' },
        ]
      : []),
  ];

  return (
    <DataCard
      title={`${title} Details`}
      cardData={details}
      onEdit={(fieldName) => onEdit(fieldName, data)}
    />
  );
};

PickupDeliveryDetails.propTypes = {
  data: PropTypes.shape({
    deliveryProvider: PropTypes.string,
    address1: PropTypes.string,
    city: PropTypes.string,
    firstLevelSubdivisionCode: PropTypes.string,
    totalDeliveryCost: PropTypes.number,
    courierTip: PropTypes.number,
    status: PropTypes.string,
  }),
  title: PropTypes.string.isRequired,
  onEdit: PropTypes.func.isRequired,
};
